import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { SignupRequest, SignupResponse } from './tenant-signup.types';

@Injectable({ providedIn: 'root' })
export class TenantSignupService {
  private readonly http = inject(HttpClient);

  signup(req: SignupRequest): Observable<SignupResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });
    return this.http.post<SignupResponse>(environment.tenantSignupUrl, req, { headers });
  }
}
